import React from 'react';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';

import logo1 from '../img/logo_tr.png';
import logo2 from '../img/logo.png';
import LanguageSwitcher from './LanguageSwitcher.jsx';

import '../styles/navbar.css';

class Navbar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			logo: logo1,
		};
	}

	isHomePage = () => {
		return window.location.pathname === '/' || window.location.pathname === '';
	};

	componentDidMount() {
		const nav = $('nav');
		let navHeight = nav.outerHeight();

		$('.navbar-toggler').on('click', function () {
			if (!$('#mainNav').hasClass('navbar-reduce')) {
				$('#mainNav').addClass('navbar-reduce');
			}
		});

		if (this.isHomePage()) {
			$('body').scrollspy({
				target: '#mainNav',
				offset: navHeight,
			});
		}

		$('.js-scroll').on('click', function () {
			$('.navbar-collapse').collapse('hide');
		});

		this._scrollHandler = () => {
			if (window.pageYOffset > 50) {
				document
					.querySelector('.navbar-expand-md')
					.classList.add('navbar-reduce');
				document
					.querySelector('.navbar-expand-md')
					.classList.remove('navbar-trans');
				this.setState({ logo: logo2 });
			} else {
				if (this.isHomePage()) {
					document
						.querySelector('.navbar-expand-md')
						.classList.add('navbar-trans');
					document
						.querySelector('.navbar-expand-md')
						.classList.remove('navbar-reduce');
					this.setState({ logo: logo1 });
				}
			}
		};
		window.addEventListener('scroll', this._scrollHandler, { passive: true });

		$('a.js-scroll[href*="#"]:not([href="#"])').on('click', function () {
			if (
				window.location.pathname.replace(/^\//, '') ===
					this.pathname.replace(/^\//, '') &&
				window.location.hostname === this.hostname
			) {
				var target = $(this.hash);
				target = target.length
					? target
					: $('[name="' + CSS.escape(this.hash.slice(1)) + '"]');
				if (target.length) {
					$('html, body').animate(
						{
							scrollTop: target.offset().top - navHeight + 5,
						},
						1000,
						'easeInExpo'
					);
					return false;
				}
			}
		});

		// Handle hash scroll after navigating from service/other pages
		this._handleHashOnLoad = () => {
			if (window.location.hash && this.isHomePage()) {
				const hash = window.location.hash.slice(1);
				setTimeout(() => {
					const target = document.getElementById(hash);
					if (target) {
						$('html, body').animate(
							{ scrollTop: $(target).offset().top - navHeight + 5 },
							1000,
							'easeInExpo'
						);
					}
				}, 200);
			}
		};
		this._handleHashOnLoad();

		// On service pages, set navbar to reduced state immediately
		if (!this.isHomePage()) {
			document
				.querySelector('.navbar-expand-md')
				.classList.add('navbar-reduce');
			document
				.querySelector('.navbar-expand-md')
				.classList.remove('navbar-trans');
			this.setState({ logo: logo2 });
		}
	}

	render() {
		const isHome = this.isHomePage();
		const { t } = this.props;

		return (
			<nav
				className="navbar navbar-b navbar-trans navbar-expand-md fixed-top navbar-modern"
				id="mainNav"
			>
				<div className="container">
					<a className="navbar-brand js-scroll" href={isHome ? '#home' : '/'}>
						<img
							src={this.state.logo}
							alt="logo"
							style={{ maxWidth: '100px', filter: 'drop-shadow 8px 8px 8px' }}
						/>
					</a>
					<button
						className="navbar-toggler collapsed"
						type="button"
						data-toggle="collapse"
						data-target="#navbarDefault"
						aria-controls="navbarDefault"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span></span>
						<span></span>
						<span></span>
					</button>
					<div
						className="navbar-collapse collapse justify-content-end"
						id="navbarDefault"
					>
						<ul className="navbar-nav">
							<li className="nav-item">
								<a
									className={`nav-link ${isHome ? 'js-scroll' : ''} active`}
									href={isHome ? '#home' : '/'}
								>
									{t('nav.home')}
								</a>
							</li>
							<li className="nav-item">
								<a
									className={`nav-link ${isHome ? 'js-scroll' : ''}`}
									href={isHome ? '#about' : '/#about'}
								>
									{t('nav.services')}
								</a>
							</li>
								<li className="nav-item">
								<a
									className={`nav-link ${isHome ? 'js-scroll' : ''}`}
									href={isHome ? '#contact' : '/#contact'}
								>
									{t('nav.contacts')}
								</a>
							</li>
						</ul>
						<LanguageSwitcher />
					</div>
				</div>
			</nav>
		);
	}
}

export default withTranslation()(Navbar);
